import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allCrews }) => {
  if (!allCrews) return state;
  return state.merge({ allCrews });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
const setIsCrewNameExists = (state, { isCrewExists }) => {
  return state.merge({ isCrewExists });
};
const setCrewRota = (state, { crewRotaData }) => {
  return state.merge({ crewRotaData });
};
const setCrewRotaFilters = (state, { filters }) => {
  return state.merge({ filters });
};
const setUploadResponse = (state, { uploadResponse }) => {
  return state.merge({ uploadResponse });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_IS_CREW_NAME_EXISTS,
    actionFunction: setIsCrewNameExists,
  },
  {
    actionType: ActionTypes.SET_CREW_ROTA,
    actionFunction: setCrewRota,
  },
  {
    actionType: ActionTypes.SET_CREW_ROTA_FILTERS,
    actionFunction: setCrewRotaFilters,
  },
  {
    actionType: ActionTypes.SET_UPLOAD_RESPONSE,
    actionFunction: setUploadResponse,
  },
];
